import { Type, type Static } from "@sinclair/typebox";
export const FicSyncPolicySchema = Type.Object(
  {
    enabled: Type.Boolean(),
    startupCheck: Type.Boolean(),
    intervalMinutes: Type.Integer({ minimum: 15, maximum: 1440 }),
    managementYear: Type.Integer({ minimum: 2000, maximum: 2100 }),
  },
  { additionalProperties: false },
);
export const FicSyncRequestSchema = Type.Object(
  {
    operationId: Type.String({ format: "uuid" }),
    managementYear: Type.Integer({ minimum: 2000, maximum: 2100 }),
  },
  { additionalProperties: false },
);
export const FicSyncStatusQuerySchema = Type.Object(
  {
    managementYear: Type.Optional(
      Type.Integer({ minimum: 2000, maximum: 2100 }),
    ),
  },
  { additionalProperties: false },
);
export type FicSyncPolicy = Static<typeof FicSyncPolicySchema>;
export type FicSyncRequest = Static<typeof FicSyncRequestSchema>;
export type FicSyncResource = "clients" | "quotes" | "documents" | "catalog";
export interface FicResourceFreshness {
  resource: FicSyncResource;
  label: string;
  state: "never" | "running" | "fresh" | "stale" | "partial" | "failed";
  lastAttemptAt: string | null;
  lastCompletedAt: string | null;
  lastSuccessAt: string | null;
  nextAttemptAt: string | null;
  message: string | null;
  /** Network acquisition and local review are independent. Additive for older clients. */
  downloadState?: Exclude<FicResourceFreshness["state"], "partial">;
  pendingAssociations?: number;
  lastRunWarnings?: number;
}
export interface FicSynchronizationStatus {
  companyId: string | null;
  policy: FicSyncPolicy;
  resources: FicResourceFreshness[];
  revision: string;
  queued: number;
}
